import { render, staticRenderFns } from "./LegalDocuments.vue?vue&type=template&id=0b5143b8&scoped=true"
import script from "./LegalDocuments.vue?vue&type=script&lang=js"
export * from "./LegalDocuments.vue?vue&type=script&lang=js"
import style0 from "./LegalDocuments.vue?vue&type=style&index=0&id=0b5143b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5143b8",
  null
  
)

export default component.exports